import { makeStyles, shorthands } from "@fluentui/react-components";

export const useM365PulseInfiniteScrollStyles = makeStyles({
    spinner: {
        ...shorthands.margin("16px", "0px")
    }
});
